import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  linkInfo: {}
};

export default function userRecommend(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.GET_OFFICIAL_ACCOUNTS_IMAGE:
      result.linkInfo = payload;
      break;
    default:
      result = state;
  }
  return result;
}
